import { render, staticRenderFns } from "./SortInput.vue?vue&type=template&id=03d7d1dc&scoped=true&"
import script from "./SortInput.vue?vue&type=script&lang=js&"
export * from "./SortInput.vue?vue&type=script&lang=js&"
import style0 from "./SortInput.vue?vue&type=style&index=0&id=03d7d1dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d7d1dc",
  null
  
)

export default component.exports